import type { Static } from 'runtypes';
import { Literal, Record, String } from 'runtypes';
import { CoreEventRuntype } from './core';
import { type BaseEvent, BaseEventRuntype } from './base';
import { BaseAiChatEventRuntype } from './ai-chat';
import { ClickstreamEventEnum } from 'bc-model';

const AiChatThumbsdownEventBrowserRuntype = BaseEventRuntype.And(BaseAiChatEventRuntype).And(
  Record({
    event: Literal(ClickstreamEventEnum.AI_ASSIST_THUMBS_DOWN),
    version: Literal(1),
  })
);

const AiChatThumbsdownEventServerRuntype = AiChatThumbsdownEventBrowserRuntype.And(
  CoreEventRuntype
).And(
  Record({
    sessionId: String,
  })
);

type AiChatThumbsdownBrowserEvent = Static<typeof AiChatThumbsdownEventBrowserRuntype>;
type AiChatThumbsdownServerEvent = Static<typeof AiChatThumbsdownEventServerRuntype>;

const isAiChatThumbsdownBrowserEvent = (obj: BaseEvent): obj is AiChatThumbsdownBrowserEvent => {
  return obj.event === 'AI Assist Thumbs Down';
};

const isAiChatThumbsdownServerEvent = (obj: BaseEvent): obj is AiChatThumbsdownServerEvent => {
  return obj.event === 'AI Assist Thumbs Down';
};

export {
  isAiChatThumbsdownBrowserEvent,
  isAiChatThumbsdownServerEvent,
  AiChatThumbsdownEventBrowserRuntype,
  AiChatThumbsdownEventServerRuntype,
  type AiChatThumbsdownBrowserEvent,
  type AiChatThumbsdownServerEvent,
};
